export function dialog() {
    const dialogContents =
        document.querySelectorAll<HTMLDialogElement>("[data-dialog]");

    if (dialogContents.length > 0) {
        dialogContents.forEach((dialogContent) => {
            function closeModal() {
                dialogContent.close();
                dialogContent.classList.remove("close");
                dialogContent.removeEventListener("animationend", closeModal);
            }

            const dialogButtons = document.querySelectorAll<HTMLElement>(
                `[data-open-dialog-for="${dialogContent.getAttribute("data-dialog")}"]`,
            );
            const dialogClosers =
                dialogContent.querySelectorAll<HTMLElement>(".dialog-closer");

            dialogButtons.forEach((dialogButton) => {
                dialogButton.addEventListener("click", function (e) {
                    e.preventDefault();
                    dialogContent.showModal();
                });
            });

            dialogClosers.forEach((dialogClose) => {
                dialogClose.addEventListener("click", function () {
                    dialogContent.addEventListener("animationend", closeModal);
                    dialogContent.classList.add("close");

                    if (dialogClose.classList.contains("promoter-info-close")) {
                        // fetch / im hintergrund f�r die microconversion
                        //url: /promoter/track-info-close/

                        fetch("/promoter/track-info-close/", {
                            headers: { "X-Requested-With": "XMLHttpRequest" },
                            method: "GET",
                            credentials: "same-origin",
                        }).then((response) => {
                            if (!response.ok) {
                                /*return console.log('Something went wrong');*/
                            }
                        });
                    }
                });
            });
        });
    }
}
